import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Button from '../core/button/CoreButton';
import SubSectionRow from '../core/headers/SubSectionRow';
import { SubSectionContent } from '../core/layouts/CommonLayoutStyles';
import SelectOrganizationUpgradeDialog from '../organization/billing/SelectOrganizationUpgradeDialog';
import ActivateLicenseMinorCTA from './ActivateLicenseMinorCTA';

// authorized user for Cephable Basic has organizations
export default function ExpiredLicenseCard() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const memberships = useOrganizationStore((state) => state.memberships);
    const isLicenseExpired = useCurrentUserStore((state) => state.isLicenseExpired);
    const isEmailVerified = useCurrentUserStore((state) => state.isEmailVerified);
    const [showDialog, setShowDialog] = useState(false);
    const isSingleMembership = memberships.length == 1;

    const getTitle = () => {
        return isSingleMembership
            ? t('common:organization.expired.title')
            : t('common:organization.expired.titlePlural');
    };
    const getDescription = useCallback(() => {
        if (isSingleMembership) {
            const { isAdmin, canManageBilling } = memberships[0];
            return canManageBilling || isAdmin
                ? t('common:organization.expired.admin')
                : t('common:organization.expired.user');
        }
        return t('common:organization.expired.multiple');
    }, [memberships, t, isSingleMembership]);

    const handleClick = useCallback(() => {
        if (isSingleMembership) {
            navigate(`/org/${memberships[0].organizationId}/billing/redirect/upgrade/`);
        } else {
            setShowDialog(true);
        }
    }, [isSingleMembership, memberships, navigate]);

    if (!isEmailVerified || !isLicenseExpired) {
        return null;
    }

    return (
        <>
            <SubSectionRow title={getTitle()} description={getDescription()} />
            <SubSectionContent>
                {isSingleMembership ? (
                    <>
                        <ActivateLicenseMinorCTA organizationId={memberships[0].organizationId} center={false} />
                        <Button onClick={handleClick} $color="secondary">
                            {t('common:upgrade')}
                        </Button>
                    </>
                ) : (
                    <>
                        <Button onClick={handleClick} $color="secondary">
                            {t('common:organization.viewOrganization')}
                        </Button>
                        <SelectOrganizationUpgradeDialog open={showDialog} onCancel={() => setShowDialog(false)} />
                    </>
                )}
            </SubSectionContent>
        </>
    );
}
